import axios from 'axios';

export const cartGiftcard = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const giftcardCheckbox = document.querySelector('body [name="gift_card"]');
    const giftcardCheckboxFree = document.querySelector(
      'body [name="gift_card_free"]'
    );
    const giftcardFreeInTime = document
      .querySelector('body #product_giftcard_free_variant_id')
      .getAttribute('data-in-gift-time');

    if (giftcardCheckbox == null && giftcardCheckboxFree == null) {
      return;
    }

    const giftcard_variant_id = document.querySelector(
      'body #product_giftcard_variant_id'
    ).value;
    const giftcard_free_variant_id = document.querySelector(
      'body #product_giftcard_free_variant_id'
    ).value;

    setCheckedGiftcard();

    const mainCart = document.querySelector(
      '#main .shopify-section--main-cart'
    );

    mainCart.addEventListener('change', function (event) {
      const target = event.target;
      if (
        target.getAttribute('name') == 'gift_card' &&
        target instanceof HTMLInputElement
      ) {
        if (
          giftcardCheckboxFree &&
          document.querySelector('body [name="gift_card_free"]').checked
        ) {
          changeGiftcard(
            giftcard_variant_id,
            target.checked,
            giftcard_free_variant_id
          );
        } else {
          changeGiftcard(giftcard_variant_id, target.checked, false);
        }
        if (giftcardCheckboxFree) {
          document.querySelector(
            'body [name="gift_card_free"]'
          ).checked = false;
        }
      }
      if (
        target.getAttribute('name') == 'gift_card_free' &&
        target instanceof HTMLInputElement
      ) {
        if (
          giftcardCheckbox &&
          document.querySelector('body [name="gift_card"]').checked
        ) {
          changeGiftcard(
            giftcard_free_variant_id,
            target.checked,
            giftcard_variant_id
          );
        } else {
          changeGiftcard(giftcard_free_variant_id, target.checked, false);
        }
        if (giftcardCheckbox) {
          document.querySelector('body [name="gift_card"]').checked = false;
        }
      }
    });

    if (giftcardFreeInTime == 'false') {
      const lineItems = document.querySelectorAll(
        'body .order-summary .line-item'
      );
      lineItems.forEach(function (element) {
        if (
          typeof element.dataset != 'undefined' &&
          element.dataset.variantId == giftcard_free_variant_id
        ) {
          const lineItem = removeLineItem(element.dataset.key);
          lineItem.then(function (res) {
            if (res.status == 200) {
              const cart = getCart();
              cart.then(function (res) {
                mainCart.classList.remove('loading');
                mainCart.innerHTML = res.data['main-cart'];
                setCheckedGiftcard();
                customProductBuilder();
                hideCartNote();
                hideShippingEstimator();
                hideTaxInfo();
                showNovelty();
              });
            }
          });
        }
      });
    }
  });

  const setCheckedGiftcard = () => {
    const giftcardCheckbox = document.querySelector('body [name="gift_card"]');
    const giftcardCheckboxFree = document.querySelector(
      'body [name="gift_card_free"]'
    );

    if (giftcardCheckbox == null && giftcardCheckboxFree == null) {
      return;
    }

    const giftcard_variant_id = document.querySelector(
      'body #product_giftcard_variant_id'
    ).value;
    const giftcard_free_variant_id = document.querySelector(
      'body #product_giftcard_free_variant_id'
    ).value;

    if (giftcard_variant_id && giftcardCheckbox) {
      const giftcardExists = checkGiftcardExists(giftcard_variant_id);
      if (giftcardExists) {
        giftcardCheckbox.checked = true;
      }
    }

    if (giftcard_free_variant_id && giftcardCheckboxFree) {
      const giftcardFreeExists = checkGiftcardExists(giftcard_free_variant_id);
      if (giftcardFreeExists) {
        giftcardCheckboxFree.checked = true;
      }
    }
  };

  const checkGiftcardExists = (giftcard_variant_id) => {
    const lineItems = document.querySelectorAll(
      'body .order-summary .line-item'
    );
    let checkGiftcard = false;
    lineItems.forEach(function (element) {
      if (
        typeof element.dataset != 'undefined' &&
        element.dataset.variantId == giftcard_variant_id
      ) {
        checkGiftcard = true;
      }
    });
    return checkGiftcard;
  };

  const changeGiftcard = (
    giftcard_variant_id,
    addGiftcard,
    giftcard_variant_id_remove
  ) => {
    const mainCart = document.querySelector(
      '#main .shopify-section--main-cart'
    );
    mainCart.classList.add('loading');

    if (addGiftcard) {
      // if(checkGiftcardExists(giftcard_variant_id)) {
      //     return;
      // }

      const lineItem = addLineItem(giftcard_variant_id);
      lineItem.then(function (res) {
        if (res.status == 200) {
          if (giftcard_variant_id_remove) {
            changeGiftcard(giftcard_variant_id_remove, false, false);
          } else {
            const cart = getCart();
            cart.then(function (res) {
              mainCart.classList.remove('loading');
              mainCart.innerHTML = res.data['main-cart'];
              setCheckedGiftcard();
              customProductBuilder();
              hideCartNote();
              hideShippingEstimator();
              hideTaxInfo();
              showNovelty();
            });
          }
        }
      });
    } else {
      const lineItems = document.querySelectorAll(
        'body .order-summary .line-item'
      );
      lineItems.forEach(function (element) {
        if (
          typeof element.dataset != 'undefined' &&
          element.dataset.variantId == giftcard_variant_id
        ) {
          const lineItem = removeLineItem(element.dataset.key);
          lineItem.then(function (res) {
            if (res.status == 200) {
              const cart = getCart();
              cart.then(function (res) {
                mainCart.classList.remove('loading');
                mainCart.innerHTML = res.data['main-cart'];
                setCheckedGiftcard();
                customProductBuilder();
                hideCartNote();
                hideShippingEstimator();
                hideTaxInfo();
                showNovelty();
              });
            }
          });
        }
      });
    }
  };

  const removeLineItem = async (key) => {
    const data = {
      updates: {
        [key]: 0,
      },
    };
    return await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: '/cart/update.js',
      data: data,
    });
  };

  const addLineItem = async (variantId) => {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _gift_card: true,
          },
        },
      ],
    };
    return await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: '/cart/add.js',
      data: formData,
    });
  };

  const getCart = async () => {
    return await axios({
      method: 'GET',
      url: '/cart?sections=main-cart',
    });
  };

  const customProductBuilder = () => {
    let cbpItems = document.querySelectorAll('[data-cpb-request-url]');
    if (cbpItems && cbpItems.length) {
      cbpItems.forEach(function (el) {
        var requestUrl = el.getAttribute('data-cpb-request-url');
        if (requestUrl === '') return;

        var cpbCdnRequest = new XMLHttpRequest();
        cpbCdnRequest.open('GET', requestUrl, true);
        cpbCdnRequest.onload = function () {
          if (cpbCdnRequest.status >= 200 && cpbCdnRequest.status < 400) {
            var data = JSON.parse(cpbCdnRequest.responseText);
            var tpl = '';
            var propsObj = data.cartData[0].properties;
            for (var key in propsObj) {
              if (
                key == 'SKU' ||
                key.startsWith('_', 0) ||
                key.startsWith('View', 0)
              ) {
                continue;
              }
              tpl += '<li>' + key + ': ' + propsObj[key] + '</li>';
            }
            tpl +=
              '<li class="cpbProductAlert">注文キャンセルまたは内容変更の場合は、必ずご注文後3日以内に弊社カスタマーサポートまでご連絡くださいませ。<br>キャンセルフォームからの申請はご利用いただけません。</li>';
            el.innerHTML = tpl;
          } else {
            console.error(
              'Request failed: ' +
                cpbCdnRequest.statusText +
                ". Can't get custom product properties"
            );
          }
        };
        cpbCdnRequest.onerror = function () {
          console.error("Request failed: Can't get custom product properties");
        };
        cpbCdnRequest.send();
      });
    }
  };

  const hideCartNote = () => {
    const hideCartNote = document.querySelector('#cart-settings-note').dataset
      .hideCart;
    if (hideCartNote == 'hideCart') {
      const cartNote = document.querySelector('cart-note');
      if (cartNote) {
        cartNote.style.display = 'none';
      }
    }
  };

  const hideShippingEstimator = () => {
    const hideShippingEstimate = document.querySelector(
      '#cart-shipping-estimator'
    ).dataset.hideShippingestimate;
    if (hideShippingEstimate == 'hideShippingEstimate') {
      const shipppingEstimate = document.querySelector('shipping-estimator');
      if (shipppingEstimate) {
        shipppingEstimate.style.display = 'none';
      }
    }
  };

  const hideTaxInfo = () => {
    const hideTaxInfo = document.querySelector('#cart-tax').dataset.hideTaxInfo;
    if (hideTaxInfo == 'hideTaxInfo') {
      const taxInfoSection = document.querySelector('.cart-tax-info');
      if (taxInfoSection) {
        taxInfoSection.style.display = 'none';
      }
    }
  };

  const createNoveltyElement = () => {
    // 新しい要素を作成
    const newDiv = document.createElement('div');
    newDiv.className = 'h-stack justify-start gap-2';

    const newSpan = document.createElement('span');
    newSpan.className = 'text-lg novelty_message';
    newSpan.id = 'novelty_message_container';

    // 新しい要素を組み立て
    newDiv.appendChild(newSpan);

    // 既存の要素を取得
    const existingElement = document.querySelector('#cart-total-price'); // 既存の要素のセレクタを指定

    // 兄弟要素として新しい要素を追加
    existingElement.parentNode.insertBefore(
      newDiv,
      existingElement.nextSibling
    );
  };

  const showNovelty = () => {
    const holdNoveltyCampaign = document.querySelector('#novely_minumum_price');
    if (holdNoveltyCampaign) {
      const nowtime_element = document.querySelector('#novely_now_time').value;
      const nowtime = formatDateTime(nowtime_element);
      const novely_start_time_element =
        document.querySelector('#novely_start_time').value;
      const novely_start_time = formatDateTime(novely_start_time_element);
      const novely_end_time_element =
        document.querySelector('#novely_end_time').value;
      const novely_end_time = formatDateTime(novely_end_time_element);

      if (
        nowtime.getTime() >= novely_start_time.getTime() &&
        nowtime.getTime() <= novely_end_time.getTime()
      ) {
        createNoveltyElement();
        const novelty_minimum_price = holdNoveltyCampaign.value;
        const current_cart_ammount_price =
          document.querySelector('[data-total-price]').dataset.totalPrice;
        const novelty_message_container = document.querySelector(
          '#novelty_message_container'
        );
        const price_defference =
          novelty_minimum_price - current_cart_ammount_price;
        const novelty_message =
          document.querySelector('#novelty_message').innerHTML;

        if (price_defference > 0) {
          novelty_message_container.innerHTML = `あと${price_defference.toLocaleString(
            'ja-JP',
            { style: 'currency', currency: 'JPY' }
          )} JPY${novelty_message}`;
        }
      }
    }
  };

  const formatDateTime = (dateString) => {
    const parts = dateString.split(/[\s/:]+/); // 文字列を分割して日付要素を取得

    // Dateオブジェクトに要素を設定
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // JavaScriptの月は0から始まるため、1を引きます
    const day = parseInt(parts[2]);
    const hour = parseInt(parts[3]);
    const minute = parseInt(parts[4]);
    const second = parseInt(parts[5]);

    const date = new Date(year, month, day, hour, minute, second);

    return date;
  };
};
